var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarbonSysplexDistributor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.5H6V22.5H3V19.5ZM10.5 19.5H13.5V22.5H10.5V19.5ZM18 19.5H21V22.5H18V19.5ZM18.75 13.5H12.75V12H11.25V13.5H5.25C4.42275 13.5 3.75 14.1735 3.75 15V18H5.25V15H11.25V18H12.75V15H18.75V18H20.25V15C20.25 14.1735 19.5772 13.5 18.75 13.5ZM15 1.5H9C8.17275 1.5 7.5 2.1735 7.5 3V9C7.5 9.82725 8.17275 10.5 9 10.5H15C15.8273 10.5 16.5 9.82725 16.5 9V3C16.5 2.1735 15.8273 1.5 15 1.5ZM13.9395 3L9 7.9395V3H13.9395ZM10.0605 9L15 4.0605L15.0007 9H10.0605Z",
    fill: "#B0976D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonSysplexDistributor);
export default __webpack_public_path__ + "static/media/carbon_sysplex-distributor.6c13e2459aa7f10eac05aadf6c1339c0.svg";
export { ForwardRef as ReactComponent };